import React from 'react';
import InternalImageV2 from '../internal-image-v2';
import {Link} from 'react-router'
import TextTruncate from 'react-text-truncate';
import moment from 'moment';
export default function PostsList(props) {
    const {posts} = props;
    const strip = function(html) {
        var tmp = document.createElement('DIV');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || '';
    }

    return (
        <ul className="posts-list">
            {posts.map((post) => {
                return (
                    <li key={`${post.id}-post-list-item`}>
                        <div className="featured-image">
                            <InternalImageV2 filename={post.image ? post.image.filename: undefined} alt={post.title}/>
                        </div>
                        <div className="post-content">
                            <h4 className="post-title">
                                <Link to={`/post/${post.slug}`}>{post.title}</Link>
                            </h4>
                            <div className="date-display">{moment(post.publish_date).format('YYYY-MM-DD')}</div>
                            <div>
                                <TextTruncate line={5} truncateText="…" text={strip(post.body)} />
                            </div>
                        </div>

                    </li>
                )
            })}
        </ul>
    )
}

//textTruncateChild={<Link to = {
//     `/post/${post.slug}`
// } className="btn btn-main-color"> Read on >< /Link>}



// WEBPACK FOOTER //
// ./src/js/components/post/posts-list.js